import { useAnalytics } from "@codat/analytics";
import React from "react";
import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps,
} from "react-router-dom";

interface LinkProps extends ReactRouterLinkProps {
  linkName: string;
  eventProperties?: Record<string, unknown>;
}

export const Link = (props: LinkProps) => {
  const { linkName, eventProperties, onClick, children, ...linkProps } = props;
  const { sendEvent } = useAnalytics();

  const handleOnClickWithTracking = (
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    sendEvent(`${linkName} - Click`, eventProperties);
    if (onClick) {
      onClick(e);
    }
  };
  return (
    <ReactRouterLink {...linkProps} onClick={handleOnClickWithTracking}>
      {children}
    </ReactRouterLink>
  );
};
